import { Injectable } from '@angular/core';
import { HttpClientService } from '../common/http-client.service';

import { NavbarComponent } from '../../components/navbar/navbar/navbar.component';

@Injectable()
export class UserService {
  navbarComponent: NavbarComponent;

  private url = 'users';

  constructor(private httpClient: HttpClientService) {}

  edit(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}/edit.json`);
  }

  formOptions(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { form_options: true });
  }

  getNavbarData(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_navbar_data: true });
  }

  getUserShowData(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_user_show: true });
  }

  getUserMatters(): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, { get_user_matters: true });
  }

  index(params: any = {}): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, params);
  }

  newUser(): Promise<any> {
    return this.httpClient.get(`${this.url}/new.json`);
  }

  newApiKey(id: number): Promise<any> {
    return this.httpClient.post(`${this.url}/${id}/new_api_key.json`, {});
  }

  otpSettings(): Promise<any> {
    return this.httpClient.get(`${this.url}/otp_settings.json`);
  }

  resourcePermission(resource_name: string, id: number, action: string = '', guard_name: string): Promise<any> {
    return this.httpClient.post(`${this.url}/resource_permission.json`, { resource: { id, resource_name, action, guard_name } });
  }

  save(fields: any): Promise<any> {
    if (fields.user.id) return this.httpClient.put(`${this.url}/${fields.user.id}.json`, fields);
    else return this.httpClient.post(`${this.url}.json`, fields);
  }

  saveOtpSettings(otpSettings: any): Promise<any> {
    return this.httpClient.post(`${this.url}/update_otp_settings.json`, { user: otpSettings });
  }

  signIn(params: any): Promise<any> {
    return this.httpClient.post(`${this.url}/signin.json`, params);
  }

  switchUser(userId: number): Promise<any> {
    return this.httpClient.post('/users/switch_user.json', { user_id: userId });
  }

  switchUserBack(): Promise<any> {
    return this.httpClient.post('/users/switch_user_back.json', {});
  }

  saveLateReason(reason: string, workDate?: string): Promise<any> {
    return this.httpClient.post('/staff_attendance_days/late_reason.json', {
      reason,
      work_date: workDate,
    });
  }

  saveEarlyReason(reason: string, workDate?: string): Promise<any> {
    return this.httpClient.post('/staff_attendance_days/early_reason.json', {
      reason,
      work_date: workDate,
    });
  }

  heartbeat(sessionId: string): Promise<any> {
    return this.httpClient.post('/staff_attendance_days/heartbeat.json', { session_id: sessionId });
  }

  setDevelopmentClock(time: string): Promise<any> {
    return this.httpClient.post('/development_clock/set.json', { time });
  }

  resetDevelopmentClock(): Promise<any> {
    return this.httpClient.post('/development_clock/reset.json', {});
  }

  // Check for existing Devise session and get JWT token if present
  checkSession(): Promise<any> {
    return this.httpClient.get(`${this.url}/check_session.json`);
  }
}
